export const NUTRIENT_TABLE_CONSTANTS = {
  DESKTOP_COLUMN_WIDTHS: {
    nutrient: {
      width: '225px',
      minWidth: '225px',
      padding: '0 10px',
      display: 'flex',
      alignItems: 'center',
    },
    spacer: {
      width: '20px',
    },
    current: {
      width: '100px',
      minWidth: '100px',
      padding: '0 10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    goal: {
      width: '96px',
      minWidth: '96px',
      padding: '0 10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    change: {
      width: '100px',
      minWidth: '100px',
      padding: '0 10px',
    },
    slider: {
      width: 'auto',
      minWidth: '285px',
      padding: '0 0 0 30px',
      display: 'flex',
      alignItems: 'center',
    },
  },
  // Total width: 225 + 100 + 96 + 100 + 285 = 806px
};
